// extracted by mini-css-extract-plugin
export default {"switcherWrapper":"ViewSwitcher_switcherWrapper__eziop","switcherButton":"ViewSwitcher_switcherButton__nh0zS","switcherButtonActive":"ViewSwitcher_switcherButtonActive__mBm+-"};